import { queryParamsToSession } from '../../lib/funnels/functions/v1/default/queryParamsToSession'
import { updateSession } from '../../lib/funnels/functions/v1/default/updateSession'
import { setTurboCookie, getCookieValue } from '@turbodebt/turbo-shared'
import { pageview, event } from '../../lib/funnels/functions/v1/default/ga4'
import { getUrlParams } from '../../lib/funnels/functions/v1/default/getUrlParams'

import './index.css'
import '../styles/modal.css'

document.addEventListener('DOMContentLoaded', () => {
  // -------------------

  const SESSION_ID = 'tdMainFunnel'

  queryParamsToSession(SESSION_ID)

  // abandonment modal
  const modal = /** @type {HTMLDialogElement} */ (
    document.getElementById('savingsEstimatesPopup')
  )
  const modalClose = document.getElementById('popupClose')
  const modalButton = document.getElementById('sePopupButton')
  const MODAL_COOKIE_NAME = 'savingsEstimatesModalShown'
  const MODAL_COOKIE_HOURS = 7 * 24 // 7 days
  const MODAL_SHOW_TIMEOUT = 30_000 // 30s
  let modalDisplayedThisSession = false
  const getParams = getUrlParams(window.location.search) || {}
  const queryParamForModal = getParams?.showModal === 'true'

  function shouldShowModal() {
    if (!modal) return
    if (modalDisplayedThisSession) return
    if (isClosedCookieSet()) return
    if (!queryParamForModal) return // for AB test

    try {
      if (typeof modal.showModal === 'function') {
        modal.showModal()
        event({
          action: 'chat_pop_view',
          params: {},
        })
        pageview('chat-pop-view')
      }
      modalDisplayedThisSession = true
    } catch {
      // nothing
    }
  }

  function isClosedCookieSet() {
    const cookieSet = getCookieValue(MODAL_COOKIE_NAME)
    return cookieSet && cookieSet.length > 1
  }

  function setClosedCookie() {
    setTurboCookie(MODAL_COOKIE_NAME, { 1: 1 }, { expires: MODAL_COOKIE_HOURS })
  }

  if (modalClose) {
    modalClose.addEventListener('click', function () {
      if (modal && typeof modal.close === 'function') {
        modal.close()
      }
    })
  }

  modal.addEventListener('close', function () {
    setClosedCookie()
  })

  // idle detection
  /**
   * @type {string | number | NodeJS.Timeout | null | undefined}
   */
  let idleTimer = null
  function resetIdleTimer() {
    if (idleTimer) clearTimeout(idleTimer)
    if (isClosedCookieSet() || modalDisplayedThisSession) return
    idleTimer = setTimeout(() => {
      shouldShowModal()
    }, MODAL_SHOW_TIMEOUT)
  }

  ;[
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
    'touchmove',
    'pointermove',
  ].forEach((ev) =>
    window.addEventListener(ev, resetIdleTimer, { passive: true }),
  )
  // start the idle timer
  resetIdleTimer()

  // navigated back to savings-estimates from button click
  window.addEventListener('pageshow', (e) => {
    const leftViaClick = sessionStorage.getItem('savings-left-via-click')
    if (isClosedCookieSet()) return
    if (!leftViaClick) return

    // detect back/forward navigation
    const navEntries =
      performance.getEntriesByType && performance.getEntriesByType('navigation')
    const navType =
      // @ts-ignore - ignoring .type not exist on PerformanceEntry
      navEntries && navEntries[0] && navEntries[0].type
        ? // @ts-ignore - ignoring type not exist on PerformanceEntry
          navEntries[0].type
        : // fallback for older browsers
          performance.navigation && performance.navigation.type === 2
          ? 'back_forward'
          : ''

    if (e.persisted || navType === 'back_forward') {
      shouldShowModal()
      sessionStorage.removeItem('savings-left-via-click')
    }
  })

  // desktop: exit intent
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY < 0) {
      if (isClosedCookieSet()) return
      shouldShowModal()
    }
  })

  // mobile: exit intent
  window.addEventListener('popstate', function () {
    if (isClosedCookieSet()) return
    shouldShowModal()
  })

  if (modalButton) {
    modalButton.addEventListener('click', function () {
      pageview('chat-pop-click')
      event({
        action: 'chat_pop_click',
        params: {},
      })
      setClosedCookie()
    })
  }

  // @ts-ignore
  window.clickDebtOption = function clickDebtOption(debtAmount, abTest) {
    try {
      sessionStorage.setItem('savings-left-via-click', '1')
    } catch {
      // nothing
    }
    updateDebtOwed(debtAmount, abTest)

    if (
      debtAmount === '7000' ||
      debtAmount === '7500' ||
      debtAmount === '9999'
    ) {
      window.location.href =
        '/onboarding/savings-v2/?funnel=veracity-onboarding-alt'
      return
    }

    window.location.href = '/savings-estimates/submit/'
  }

  /**
   * @param {string} debtAmount
   * @param {string} abTest
   */
  function updateDebtOwed(debtAmount, abTest) {
    updateSession(SESSION_ID, 'debtOwed', debtAmount)
    if (abTest) {
      updateSession(SESSION_ID, 'abTest', abTest)
    }
  }
})
